webpackJsonp([201485011385187],{

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return call&&(typeof call==="object"||typeof call==="function")?call:self}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}var React=__webpack_require__(1);var PureComponent=React.PureComponent;var PropTypes=__webpack_require__(8);var objectAssign=__webpack_require__(6);function noop(){}var Iframe=function(_PureComponent){_inherits(Iframe,_PureComponent);function Iframe(){_classCallCheck(this,Iframe);return _possibleConstructorReturn(this,(Iframe.__proto__||Object.getPrototypeOf(Iframe)).apply(this,arguments))}_createClass(Iframe,[{key:"render",value:function render(){var props={ref:"iframe",frameBorder:"0",src:this.props.url,target:"_parent",allowFullScreen:this.props.allowFullScreen||false,style:objectAssign({},{position:this.props.position||"absolute",display:this.props.display||"block",height:this.props.height||"100%",width:this.props.width||"100%"},this.props.styles||{}),height:this.props.height||"100%",name:this.props.name||"",width:this.props.width||"100%",onLoad:this.props.onLoad||noop,onMouseOver:this.props.onMouseOver||noop,onMouseOut:this.props.onMouseOut||noop};return React.createElement("iframe",objectAssign(props,this.props.id?{id:this.props.id}:{},this.props.sandbox?{sandbox:this.props.sandbox}:{},this.props.allow?{allow:this.props.allow}:{},this.props.className?{className:this.props.className}:{}))}}]);return Iframe}(PureComponent);Iframe.propTypes={url:PropTypes.string.isRequired,id:PropTypes.string,className:PropTypes.string,width:PropTypes.string,position:PropTypes.string,display:PropTypes.string,name:PropTypes.string,height:PropTypes.string,onLoad:PropTypes.func,sandbox:PropTypes.string,allow:PropTypes.string,onMouseOver:PropTypes.func,onMouseOut:PropTypes.func,styles:PropTypes.object,allowFullScreen:PropTypes.bool};exports.default=Iframe;


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactIframe = __webpack_require__(451);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var location = function location() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Clinic Location'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Phone: (206) 335-8017'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Email:\xA0',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:sharkeyacupuncture@gmail.com' },
	        ' ',
	        'sharkeyacupuncture@gmail.com'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'u',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Seattle (Fremont):'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3609 1st Ave NW Seattle, WA 98107'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactIframe2.default, {
	        url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2687.6000302681286!2d-122.36014128459988!3d47.65333879274163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549015a91d730525%3A0xe5b093b56acb8c65!2sNicole+Sharkey%2C+EAMP%2C+L.Ac.!5e0!3m2!1sen!2sus!4v1524718200282',
	        width: '600px',
	        height: '450px',
	        position: 'relative'
	      })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Hours:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Monday 4:30-7:30pm'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Tuesday 11-6 pm'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Thursday 9-1 pm'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Sunday 10-2 pm'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'li',
	          null,
	          'The clinic is located in the Fremont neighborhood. It is accessible by bus lines 28 and 46. Free street parking is available around the clinic.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Gift Certificates:'
	      ),
	      _react2.default.createElement('br', null),
	      'Please contact me at (206) 335-8017 or\xA0',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:sharkeyacupuncture@gmail.com' },
	        'sharkeyacupuncture@gmail.com'
	      ),
	      ' ',
	      'if you would like to purchase a gift certificate for a loved one.'
	    )
	  );
	};
	
	exports.default = location;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-clinic-location-js-72d501a97f64d2a4c0e1.js